import { useNavigationEvent } from '@@components/utils/NavigationEvents';
import { forwardRef, Ref } from 'react';
import Link, { LinkProps } from 'next/link';

/**
 * Types
 */
type NLinkProps<Route> = LinkProps<Route>;

/**
 * Component: NLink
 */
export default forwardRef(function NLink<Route>({ onClick, children, ...props }: NLinkProps<Route>, ref: Ref<HTMLAnchorElement>) {
  const { setUrl } = useNavigationEvent();
  return (
    <Link
      ref={ref}
      onClick={(e) => {
        // NavigationEvent.emit('navigation-started', props.href);

        setUrl((props.href ?? '') as string);
        onClick?.(e);
      }}
      {...props}
    >
      {children}
    </Link>
  );
});
